import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HTTP } from "../api/http-common";
import EventCommonView from "./EventCommonView";

function EventDetails() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await HTTP.get(`/user/event/${id}`);
        if (response.data) {
          setEvent(response.data);
        } else {
          console.error("Event data is empty");
        }
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };
    fetchEventDetails();
  }, [id]);

  if (!event) {
    return <p className="text-center mt-10">Loading event details...</p>;
  }

  const formatTime = (time) => {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(":");
    return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Function to generate Google Calendar URL
  const getGoogleCalendarUrl = () => {
    if (!event.title || !event.start_date || !event.start_time || !event.end_time) return "#";
    
    return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}
    &dates=${event.start_date.replace(/-/g, "")}T${event.start_time.replace(/:/g, "")}00Z/
    ${event.start_date.replace(/-/g, "")}T${event.end_time.replace(/:/g, "")}00Z
    &details=${encodeURIComponent(event.description || "No description")}
    &location=${encodeURIComponent(event.address || "No location")}`;
  };

  // Function to generate Outlook Calendar URL
  const getOutlookCalendarUrl = () => {
    if (!event.title || !event.start_date || !event.start_time || !event.end_time) return "#";
    
    return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(event.title)}
    &startdt=${event.start_date}T${event.start_time}
    &enddt=${event.start_date}T${event.end_time}
    &body=${encodeURIComponent(event.description || "No description")}
    &location=${encodeURIComponent(event.address || "No location")}
    &allday=false&path=/calendar/action/compose`;
  };

  // Function to generate an iCalendar (.ics) file URL
  const getICalendarUrl = () => {
    if (!event.title || !event.start_date || !event.start_time || !event.end_time) return "#";

    const formatDate = (date, time) => `${date.replace(/-/g, "")}T${time.replace(/:/g, "")}00Z`;

    const icsData = `BEGIN:VCALENDAR
BEGIN:VEVENT
SUMMARY:${event.title}
DTSTART:${formatDate(event.start_date, event.start_time)}
DTEND:${formatDate(event.start_date, event.end_time)}
DESCRIPTION:${event.description || "No description"}
LOCATION:${event.address || "No location"}
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsData], { type: "text/calendar" });
    return URL.createObjectURL(blob);
  };

  return (
    <EventCommonView
      event={event}
      dropdownOpen={dropdownOpen}
      setDropdownOpen={setDropdownOpen}
      getGoogleCalendarUrl={getGoogleCalendarUrl}
      getOutlookCalendarUrl={getOutlookCalendarUrl}
      getICalendarUrl={getICalendarUrl}
      formatTime={formatTime}
    />
  );
}

export default EventDetails;
